// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../components/smart-table/smart-table.model';

/** @ngInject */
export function Controller(
    $scope,
    $uibModal,
    Alert,
    DestructiveOperationModal,
    UserEmailsService,
) {
    this.$onInit = () => {
    const emails = this.emails;
    $scope.st = new SmartTable();

    $scope.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
    $scope.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');

    $scope.showDeleteEmailDestructiveOp = function(emailDtoObject) {
        $scope.emailToBeDeleted = emailDtoObject;
        if(emailDtoObject.userEmail.status == null){
            UserEmailsService.delete({
                id : emailDtoObject.userEmail.id
            }).$promise.then(function(data) {
                $scope.deleteEmailSuccess();
            });
        }else {
            const url = `app/rest/emails/active_email/${emailDtoObject.userEmail.id}`;
            DestructiveOperationModal({
                titleKey: 'emails.delete_email_modal',
                textKey: 'emails.messages.warning_delete_email',
                http: {method: 'DELETE', url}
            }).then(() => {
                $scope.deleteEmailSuccess();
            });
        }
    };
    
    $scope.deleteEmailSuccess = function() {
        Alert('success', 'emails.messages.email_deleted');
        emails.splice(emails.indexOf($scope.emailToBeDeleted), 1);
    };

    $scope.createUserEmail = function() {
        $uibModal.open({component: 'addUserEmail'}).result.then((data) => {
            emails.push({userEmail: data, companyEmail: false});
        });
    };

    $scope.resendVerificationEmail = function(emailDtoObject) {
        var id = emailDtoObject.userEmail.id;
        UserEmailsService.get({
            id : id
        }).$promise.then(function(data) {
            Alert('success', 'emails.messages.verification_link_resend');
        });

    }
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/emails/emails.controller.js